import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { Typography, Image, Row, Col, Avatar, Space, Dropdown, Card } from 'antd';
import { ExpandMore } from "@mui/icons-material";
import {ExportOutlined} from "@ant-design/icons";
import CompanyLogo from "../Pages/Company/CompanyLogo";

const CompanyNavigator = ({company})=>{
    const navigate = useNavigate();
    return (
        <Space direction={'vertical'}>
            <Typography.Text strong onClick={()=>navigate('/company/details/edit')}>
                {company?.company_name}
            </Typography.Text>
            <Typography.Link>{company?.website_url} <ExportOutlined style={{paddingLeft: 2}} /></Typography.Link>
        </Space>
    )
}

const CompanyBrand = ({imgUrl})=>{
    return (
        <div style={{textAlign: 'center'}}>
            <Image
                src={imgUrl}
                alt="Brand"
                preview={false} // Disable click-to-preview functionality
                style={{ maxWidth: '100%', height: 70 }} // Adjust size as needed
            />
        </div>
    )
}


const HomeHeader = ({username, company}) => {
  const navigate = useNavigate();
  const cid = company?.cid;
  const companyBrandUrl = company?.logo_url;

  console.log(company);

  const handleNavigate = (route) => {
    navigate(route);
  }

  const menuItems = [
    {
      key: 'touchpoints',
      label: "Touchpoints",
      onClick: ()=>handleNavigate('/beta/touchpoints')
    },
    {
        key: 'compare',
        label: 'Comparison v2 (BETA)',
        onClick: () => handleNavigate('/beta/comparison')
    },
    {
      key: 'simulate',
      label: 'Simulate',
      onClick: () => handleNavigate('/beta/simulate')
    },
    {
        key: 'journey',
        label: 'Client Journey',
        onClick: () => handleNavigate('/beta/journey')
    }

  ];

  return (



      <Card bordered={false}
            title={
              <Row align={'middle'} gutter={16} >
                  <Col>
                      <Avatar size={'large'} style={{ background: '#000' }}>
                          {username && username.slice(0, 1).toUpperCase()}
                      </Avatar>
                  </Col>
                  <Col>
                      <Typography.Text ellipsis={true} style={{fontSize: '1.1rem', fontFamily: "SF Pro Display"}}
                                       onClick={() => handleNavigate('/settings')}
                                       strong
                      >
                          {username}
                      </Typography.Text>
                  </Col>
              </Row>
            }
            extra={
              <Dropdown menu={{ items: menuItems }} placement="bottomRight">
                <Button variant={'outlined'} size={'small'} color={'primary'}
                        endIcon={<ExpandMore/>}>More</Button>
              </Dropdown>
            }

      >
          <Row justify={'space-between'} align={'middle'}>
              <Col>
                  {company && <CompanyNavigator company={company} />}
              </Col>
              <Col>
                  {cid && <CompanyLogo imgUrl={companyBrandUrl} companyId={cid} editable={true} size={'medium'} />}
              </Col>
          </Row>
      </Card>
  );
};

export default HomeHeader;